// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sectionbox-loading-spinner{left:auto;right:0;top:0;z-index:99}.sectionbox-loading-spinner svg{width:60px;height:60px;fill:#727272;stroke:#727272}.sectionbox-loading-spinner svg rect{fill:#727272}.sectionbox-loading-spinner-bottom{top:calc(75% - 30px)}.sectionbox-loading-spinner-center{left:calc(50% - 30px);top:calc(50% - 30px)}.sectionbox-loading-content{filter:blur(1.5px);-webkit-filter:blur(1.5px);pointer-events:none}", ""]);
// Exports
module.exports = exports;
